class Highscores {
    constructor() {
        this.reset();
    }

    reset() {
        this.chunk = 0;
        this.friend = false;
        this.type = '';
        this.amount = 20;
        this.gameId = null;
    }

    getNextChunk() {
        this.chunk++;
        this.populateList(true);
        document.getElementById("see_less").removeAttribute("disabled");
    }

    getPreviousChunk() {
        if (this.chunk > 0) {
            this.chunk--;
            this.populateList(true);
            if (this.chunk < 1) {
                document.getElementById("see_less").setAttribute("disabled", "");
            }
        }
    }

    changeType(type) {
        this.chunk = 0;
        this.type = type.options[type.selectedIndex].id;
        this.populateList();
    }

    getHighscore(friend) {
        this.friend = friend;
        this.chunk = 0;
        this.populateList();
    }

    populateList(interaction = false) {
        if (interaction) {
            let list = $("#highscoreList");
            list.fadeTo(200, 0, () => {
                app.ajax.inject('/services/game/highscore/' + this.gameId, "#highscoreList", false, () => {
                    list.fadeTo(200, 1);
                }, null, {type: this.type, friend: this.friend, chunk: this.chunk, amount: this.amount, interaction: interaction});
            });
        } else {
            app.ajax.inject('/services/game/highscore/' + this.gameId, "#highscores", false, null, null, {type: this.type, friend: this.friend, chunk: this.chunk, amount: this.amount, interaction: interaction});
        }
    }

    init(gameId) {
        this.reset();
        this.gameId = gameId;
        this.populateList();
    }
}
